// import React, { useEffect, useState } from "react";
// import "./Dashboard.css";
// import Dashboard_header from "./dashboard_header/Dashboard_header";
// import Dashboard_sidebar from "./dashboard_sidebar/Dashboard_sidebar";
// import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

// function Dashboard() {
//   const [collapsed, setCollapsed] = useState(false);
//   const navigate = useNavigate();
//   const { role } = useParams();
//   const location = useLocation();

//   const handleMenuSelect = (menu) => {
//     const base = `/portal`;

//     const ROUTES = {
//       83: `${base}/student/dashboard`,
//       84: `${base}/student/applications`,
//       85: `${base}/student/documents`,
//       "To-Do Task": `${base}/student/todo-task`,
//       86: `${base}/student/billing-manegment`,
//       "Language Test": `${base}/student/language-test`,
//       87: `${base}/student/support`,
//       88: `${base}/student/profile`,

//       74: `${base}/college/college-dashboard`,
//       75: `${base}/college/college-intern`,
//       76: `${base}/college/college-offer`,
//       "Global Map": `${base}/college/college-global-map`,
//       77: `${base}/college/college-document`,
//       78: `${base}/college/college-profile`,

//       79: `${base}/hotel/hotel-dashboard`,
//       80: `${base}/hotel/hotel-intern`,
//       "Global Map": `${base}/hotel/hotel-global-map`,
//       81: `${base}/hotel/hotel-document`,
//       82: `${base}/hotel/hotel-profile`,

//       Dashboard: `${base}/admin/admin-dashboard`,
//       9: `${base}/admin/admin-country`,
//       13: `${base}/admin/admin-state`,
//       17: `${base}/admin/admin-city`,
//       21: `${base}/admin/admin-pincode`,
//       37: `${base}/admin/admin-faq`,
//       111: `${base}/admin/admin-student-document`,
//       1: `${base}/admin/admin-role`,
//       108: `${base}/admin/admin-student`,
//       109: `${base}/admin/admin-college`,
//       110: `${base}/admin/admin-hotel`,
//       50: `${base}/admin/admin-programhighlight`,
//       54: `${base}/admin/admin-eligibilityrequirement`,
//       58: `${base}/admin/admin-careerrequirement`,
//       62: `${base}/admin/admin-requirementdocument`,
//       66: `${base}/admin/admin-document`,
//       70: `${base}/admin/admin-requirement`,
//       25: `${base}/admin/admin-university`,
//       89: `${base}/admin/admin-course`,
//       93: `${base}/admin/admin-accomodation`,
//       97: `${base}/admin/admin-studyprogram`,
//       101: `${base}/admin/admin-internship`,
//       105: `${base}/admin/admin-support`,
//     };

//     navigate(ROUTES?.[menu] || base);
//   };

//   return (
//     <section className="Dashboard">
//       <Dashboard_header />

//       <div className="Dashboard_section_holder">
//         <div
//           className={`sidebar_section ${collapsed ? "sidebar_collapsed" : ""}`}
//         >
//           <Dashboard_sidebar
//             collapsed={collapsed}
//             setCollapsed={setCollapsed}
//             onMenuSelect={handleMenuSelect}
//             role={role}
//           />
//         </div>

//         <div
//           className={`content_section portal_dashboard ${
//             collapsed ? "content_expanded" : ""
//           }`}
//         >
//           <Outlet />
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Dashboard;

import React, { useContext, useState } from "react";
import "./Dashboard.css";
import Dashboard_header from "./dashboard_header/Dashboard_header";
import Dashboard_sidebar from "./dashboard_sidebar/Dashboard_sidebar";
import { Outlet, useParams } from "react-router-dom";
import { Context } from "../../utils/context";

function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);
  const { role } = useParams();
  const { usertype } = useContext(Context);

  return (
    <section className="Dashboard">
      <Dashboard_header />

      <div className="Dashboard_section_holder">
        <div
          className={`sidebar_section ${collapsed ? "sidebar_collapsed" : ""}`}
        >
          <Dashboard_sidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            role={role}
          />
        </div>

        <div
          className={`content_section portal_dashboard ${
            collapsed ? "content_expanded" : ""
          }`}
        >
          <Outlet />
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
